import { Utils } from '@gv/triage-components';
import { Duration } from 'dayjs/plugin/duration';

const { formatDuration } = Utils.Date;

export const formatAudioTime = (value: number): string =>
  formatDuration(value, (duration: Duration) => duration.format('m:ss'));
